var map = {
	"./": 43781,
	"./brandConfig": 97346,
	"./brandConfig.js": 97346,
	"./index": 43781,
	"./index.js": 43781,
	"./vc-sportshub-za-en": 16392,
	"./vc-sportshub-za-en/": 16392,
	"./vc-sportshub-za-en/index": 16392,
	"./vc-sportshub-za-en/index.js": 16392,
	"./vc-sportshub-za-en/styles": 74179,
	"./vc-sportshub-za-en/styles/": 74179,
	"./vc-sportshub-za-en/styles/index": 74179,
	"./vc-sportshub-za-en/styles/index.js": 74179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6612;